export default "__VITE_ASSET__yP5rLKxD__"